/* eslint-disable react/jsx-no-target-blank */
import { Button } from '@cian/button-component';
import * as React from 'react';
import { ElementInViewport } from '../../common/components/elementInViewport';

import { ICountrysideBuilderProjectBlock } from '../../types';
import { getUTMDataForLink } from '../../utils/getUTMDataForLink';
import { mergeUrlWithAdditionalQuery } from '../../utils/mergeUrlWithAdditionalQuery';

import * as styles from './CountrysideBuilderProjectsBlock.css';
import {
  trackProjectsBlockButtonClick,
  trackProjectsBlockPhotoClick,
  trackProjectsBlockRender,
  trackProjectsBlockView,
} from './tracking';

export interface ICountrysideBuilderProjectsBlockProps {
  projectBlock: ICountrysideBuilderProjectBlock | null | undefined;
  offerId: number;
}

export class CountrysideBuilderProjectsBlock extends React.Component<ICountrysideBuilderProjectsBlockProps> {
  public componentDidMount() {
    const { projectBlock, offerId } = this.props;

    if (projectBlock) {
      setTimeout(() => {
        trackProjectsBlockRender(offerId);
      }, 500);
    }
  }

  public render() {
    const { projectBlock, offerId } = this.props;
    if (!projectBlock) {
      return null;
    }

    return (
      <ElementInViewport
        onChange={isVisible => {
          if (isVisible) {
            trackProjectsBlockView(offerId);
          }
        }}
      >
        <div className={styles['container']}>
          <strong className={styles['title']}>Сколько стоит построить здесь дом?</strong>
          <p className={styles['description']}>
            Бесплатно поможем подобрать проект дома, рассчитаем стоимость
            <br />и предложим проверенных строителей
          </p>
          <ul className={styles['list']}>
            {projectBlock.projects.map(({ imageUrl, title, description, link }, index) => (
              <li key={index} className={styles['item']}>
                <a
                  className={styles['link']}
                  href={mergeUrlWithAdditionalQuery(link, getUTMDataForLink('projects', offerId, index + 1))}
                  target="_blank"
                  rel="nofollow noopener"
                  onClick={this.handleProjectsBlockPhotoClick}
                >
                  <img src={imageUrl} alt={title} className={styles['item_image']} />
                </a>
                <span className={styles['item_title']}>{title}</span>
                <p className={styles['item_description']}>{description}</p>
              </li>
            ))}
          </ul>
          {projectBlock.link && (
            <div className={styles['button_container']}>
              <Button onClick={this.handleProjectsBlockButtonClick(projectBlock.link)}>Посмотреть все дома</Button>
            </div>
          )}
        </div>
      </ElementInViewport>
    );
  }

  private handleProjectsBlockPhotoClick = () => {
    trackProjectsBlockPhotoClick(this.props.offerId);
  };

  private handleProjectsBlockButtonClick = (link: string) => () => {
    const { offerId } = this.props;
    trackProjectsBlockButtonClick(offerId);

    const utmQuery = getUTMDataForLink('projects', offerId);
    const url = mergeUrlWithAdditionalQuery(link, utmQuery);

    window.open(url, '_blank');
  };
}
